<template>
  <base-table ref="table"
              :data="table.data"
              :columns="table.columns"
              thead-classes="text-primary">
  </base-table>
</template>
<script>
import {BaseTable} from "@/components";

export default {
  props: ['date'],
  components: {
    BaseTable
  },
  computed: {
    dateJoined() {
      console.log('ok');
      let dd = String(this.date.getDate()).padStart(2, '0');
      let mm = String(this.date.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = this.date.getFullYear();
      return yyyy + mm + dd;
    }
  },
  data() {
    return {
      table: {}
    }
  },
  methods: {
    sendLoginm() {
      this.table = {};
      this.axios
        .get('/race?date=' + this.dateJoined, {
          headers: {
            'Authorization': "Bearer " + localStorage.getItem('access_token')
          }
        })
        .then((response) => {
          this.table = response['data']
        });
    }
  },
  watch: {
    date() {
      this.sendLoginm();
    }
  },
  mounted() {
    this.sendLoginm();
  }
}
</script>
<style>
</style>
